import React, { useEffect, useRef, useState } from 'react'
import './datalist-open.scss'
import searchIcon from '../../../assets/chevron-down.svg'

type Option = { id: number; name: string };

interface DatalistOpenProps {
    name: string;
    id: string;
    options: Array<Option>;
    onChange: any;
    value: any;
    onAsyncSearch?: (keyword: string) => Promise<Option[]>;
}

const DatalistOpen = (props: DatalistOpenProps) => {

    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState(props.value || '');
    const [filteredOptions, setFilteredOptions] = useState<Array<Option>>([]);
    const [searchValue, setSearchValue] = useState('')
    const ref: any = useRef(null);

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current?.contains(event.target)) {
                handleClose();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [])

    const handleClose = () => {
        setSearchValue('')
        setIsOpen(false);
    }

    const handleOpen = () => {

        if (isOpen) {
            setSearchValue('')
        }

        setIsOpen(!isOpen);
    }

    const handleOnChange = (e: any) => {
        setSearchValue(e.target.value)
    }

    const handleOptionClick = (option: any) => {
        setSearchValue('')
        setValue({...option, id: null});
        setIsOpen(false);
    }

    const filterDataAsync = async (searchValue:string) => {
        let options = await props.onAsyncSearch(searchValue);
        setFilteredOptions(options);
    }

    const filterData = async (searchValue:string) => {
      setFilteredOptions(
        props.options.filter((option) =>
          option.name.toUpperCase().includes(searchValue.toUpperCase())
        )
      );
    }

    useEffect(() => {
        props.onChange(JSON.stringify(value), props.id);
    }, [value])

    useEffect(() => {
        let debounce = true;
        if(!props.onAsyncSearch) {
            // Do a search syncronously from options prop
            filterData(searchValue);
            return;
        }
        // Do a search asyncronously applying debounce
        setTimeout(() => {
            if (debounce) {
                filterDataAsync(searchValue)
            }
        }, 1000)
        return () => {
            debounce = false;
        }
    }, [searchValue]);

    return (
        <div className="a-datalist-open" ref={ref}>
            <button
                onClick={handleOpen}
                className="a-datalist-open__button"
            >
                {props.value?.name || 'Selecciona'}
                <img
                    src={searchIcon}
                    alt={isOpen ? 'Cerrar' : 'Abrir'}
                    className={`a-datalist-open__button__search-icon ${isOpen ? 'a-datalist-open__button__search-icon--open' : ''}`}
                />
            </button>

            {
                isOpen &&
                <div className="a-datalist-open__section">
                    <input
                        className="a-datalist-open__section__hidden"
                        type='text'
                        required
                        value={value}
                        name={props.id}
                        onChange={props.onChange}
                    ></input>
                    <input type="text" name="search" value={searchValue} placeholder="BUSCAR" onChange={handleOnChange} autoComplete="off" autoFocus />
                    <div className="a-datalist-open__section__options">
                        {
                            filteredOptions.map((option) => (
                                <a
                                    className="a-datalist-open__section__options__option"
                                    onClick={() => handleOptionClick(option)}
                                    key={option.id}
                                >
                                    {option.name}
                                </a>
                            ))
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default DatalistOpen;